import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaGem, FaCalendarAlt, FaUsers, FaChartBar, FaCoins } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStatGems extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected_action: 6,
            actions_info: {},
            period_average: {},
            stars_daily_average: {},
            stars_daily_stats: {},
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            options_stars: null,
            series_star: null,
            current: {}
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const stars = await AdminService.getGemsUsage(this.state.start_date, this.state.end_date, this.state.selected_action)
        const actions_by_player = [], nb_actions = [], nb_players = [], nb_stars = [], stars_by_action = [], stars_by_player = []
        Object.keys(stars.daily_stats).map(key => actions_by_player.push(stars.daily_stats[key].actions_by_player))
        Object.keys(stars.daily_stats).map(key => nb_actions.push(stars.daily_stats[key].nb_actions))
        Object.keys(stars.daily_stats).map(key => nb_players.push(stars.daily_stats[key].nb_players))
        Object.keys(stars.daily_stats).map(key => nb_stars.push(stars.daily_stats[key].nb_assets))
        Object.keys(stars.daily_stats).map(key => stars_by_action.push(stars.daily_stats[key].assets_by_action))
        Object.keys(stars.daily_stats).map(key => stars_by_player.push(stars.daily_stats[key].assets_by_player))
        this.setState({
            actions_info: stars.actions_info,
            period_average: stars.period_average,
            stars_daily_average: stars.daily_average,
            stars_daily_stats: stars.daily_stats,
            options_stars: { chart: { id: "stars-bar" }, xaxis: { categories: Object.keys(stars.daily_stats) } },
            actions_by_player: [{ name: "stars", data: actions_by_player }],
            nb_actions: [{ name: "stars", data: nb_actions }],
            nb_players: [{ name: "stars", data: nb_players }],
            nb_stars: [{ name: "stars", data: nb_stars }],
            stars_by_action: [{ name: "stars", data: stars_by_action }],
            stars_by_player: [{ name: "stars", data: stars_by_player }],
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Gems Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Gems' }
                ]}
            >
                <div className="space-y-6">
                    {/* Page Header with Gradient */}
                    <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-purple-600 rounded-xl shadow-lg p-6 text-white">
                        <div className="flex items-center justify-between flex-wrap gap-4">
                            <div className="flex items-center gap-4">
                                <div className="p-4 bg-white/20 rounded-xl backdrop-blur-sm">
                                    <FaGem className="text-4xl" />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-bold">Gems Analytics</h2>
                                    <p className="text-white/90 mt-1">Track premium currency usage and economy health</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Date Range Filters */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <FaCalendarAlt className="text-purple-600" />
                            Date Range
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                                <input 
                                    type="date" 
                                    value={this.state.start_date} 
                                    onChange={(e) => this.setState({ start_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                                <input 
                                    type="date" 
                                    value={this.state.end_date} 
                                    onChange={(e) => this.setState({ end_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Action Filter */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <label className="block text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                            <FaChartBar className="text-purple-600" />
                            Filter by Action Type
                        </label>
                        <select 
                            value={this.state.selected_action}
                            onChange={(e) => this.setState({ selected_action: e.target.value }, () => this.loadStats())}
                            className="w-full md:w-auto min-w-[300px] px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all bg-white"
                        >
                            <option value={this.state.selected_action}>{this.state.actions_info[this.state.selected_action]}</option>
                            {Object.keys(this.state.actions_info).map(key => key !== this.state.selected_action &&
                                <option key={key} value={key}>{this.state.actions_info[key]}</option>
                            )}
                        </select>
                    </div>

                    {/* Period Statistics */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900 text-lg">Period Statistics Breakdown</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th colSpan={3} className="px-6 py-4 text-center text-sm font-semibold text-gray-700 border-r border-gray-200">
                                            <div className="flex items-center justify-center gap-2">
                                                <FaChartBar className="text-blue-600" />
                                                Daily Average
                                            </div>
                                        </th>
                                        <th colSpan={3} className="px-6 py-4 text-center text-sm font-semibold text-gray-700">
                                            <div className="flex items-center justify-center gap-2">
                                                <FaChartBar className="text-purple-600" />
                                                Period Average
                                            </div>
                                        </th>
                                    </tr>
                                    <tr className="bg-gray-100 border-t border-gray-200">
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Nb Actions</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Nb Players</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase border-r border-gray-200">Nb Gems</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Actions/Player</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Gems/Action</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Gems/Player</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-purple-50 transition-colors">
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.stars_daily_average.nb_actions || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-cyan-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.stars_daily_average.nb_players || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-200">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                                                <span className="text-lg font-bold text-purple-600">{this.state.stars_daily_average.nb_assets || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.period_average.actions_by_player || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-pink-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.period_average.assets_by_action || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                                                <span className="text-lg font-bold text-purple-600">{this.state.period_average.assets_by_player || 0}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Charts Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaChartBar className="text-purple-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Actions by Player</h4>
                            </div>
                            {this.state.actions_by_player && <Chart options={this.state.options_stars} series={this.state.actions_by_player} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaChartBar className="text-blue-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Actions</h4>
                            </div>
                            {this.state.nb_actions && <Chart options={this.state.options_stars} series={this.state.nb_actions} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaUsers className="text-cyan-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Players</h4>
                            </div>
                            {this.state.nb_players && <Chart options={this.state.options_stars} series={this.state.nb_players} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaGem className="text-purple-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Gems</h4>
                            </div>
                            {this.state.nb_stars && <Chart options={this.state.options_stars} series={this.state.nb_stars} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaCoins className="text-pink-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Gems by Action</h4>
                            </div>
                            {this.state.stars_by_action && <Chart options={this.state.options_stars} series={this.state.stars_by_action} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaUsers className="text-indigo-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Gems by Player</h4>
                            </div>
                            {this.state.stars_by_player && <Chart options={this.state.options_stars} series={this.state.stars_by_player} type="bar" height={300} />}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatGems)